enum PaymentMethod {
    Invoice = 'Invoice',
    Account = 'Account',
    Installment = 'Installment',
    AdvanceInvoice = 'AdvanceInvoice',
    Card = 'Card',
    BankTransfer = 'BankTransfer',
    Swish = 'Swish',
    Amex = 'Amex',
    Vipps = 'Vipps',
    MobilePay = 'MobilePay',
    Ideal = 'Ideal',
}

const paymentMethodDisplayNameOverrides: Partial<Record<PaymentMethod, string>> = {
    [PaymentMethod.Ideal]: 'iDEAL | Wero',
};

export const getPaymentMethodDisplayName = (
  method: string | undefined
): string | undefined => {
  if (!method) return method;

  const override = paymentMethodDisplayNameOverrides[method as PaymentMethod];
  return override ?? method;
};

export default PaymentMethod;
